<mat-card class="mb-25 personal-info-card tagus-card">
  <mat-card-header class="border-bottom">
    <h5 class="mb-0">References</h5>
    <span class="gray-color align-right"></span>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="!hasData && !createReference">No references to display</div>
    <div *ngIf="hasData">
      <div
        *ngFor="let reference of references.data"
        class="row"
        style="padding-bottom: 15px"
      >
        <span class="fw-semibold d-inline-block">{{
          reference.createdAt | date : "long"
        }}</span>
        <span class="gray-color align-right"
          >{{ reference.referenceType }} |
        </span>
        <span class="gray-color align-right">{{ reference.referenceId }}</span>
      </div>
    </div>
    <div *ngIf="createReference" class="row">
      <label class="d-block mb-12 fw-semibold gray-color">Reference Type</label>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="newReference.referenceType" type="text" />
      </mat-form-field>
    </div>
    <div *ngIf="createReference" class="row">
      <label class="d-block mb-12 fw-semibold gray-color">Reference Id</label>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="newReference.referenceId" type="text" />
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <div class="text-end" style="padding: 30px">
      <button
        *ngIf="canEdit && !createReference"
        mat-flat-button
        (click)="addReference($event)"
        color="add-comment"
      >
        Add Reference
      </button>
      <button
        *ngIf="createReference"
        mat-flat-button
        (click)="cancelReference()"
        color="cancel"
      >
        Cancel
      </button>
      <button
        *ngIf="createReference"
        mat-flat-button
        (click)="saveReference()"
        color="add-comment"
      >
        Save Reference
      </button>
    </div>
  </mat-card-footer>
</mat-card>
